import { HeaderImageMap } from "@/enums";
import { Mask, Toast } from "antd-mobile";
// import { CheckCircleOutline } from "antd-mobile-icons";
import { changeUserInfo, UserInfoRep } from "@/api/user";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import React from "react";
import styles from "./index.module.scss";

interface Props {
    visible: boolean;
    useInfo: UserInfoRep;
    onClose?: (needRefresh?: boolean) => void;
}

interface ImgItem {
    key: number;
    img: string;
}

const ChangeAvatar: React.FC<Props> = ({ visible = false, useInfo, onClose }) => {
    const t = useTranslations("ProfilePage");

    const [innerVisible, setInnerVisible] = React.useState<boolean>(false);
    const [curAvatar, setCurAvatar] = React.useState(useInfo?.avatar || 1);

    const imgs: ImgItem[] = React.useMemo(() => {
        const result: ImgItem[] = [];
        for (let [key, value] of HeaderImageMap.entries()) {
            result.push({
                img: value.img,
                key: Number(key),
            });
        }
        return result;
    }, []);

    React.useEffect(() => {
        setInnerVisible(visible);
    }, [visible]);

    React.useEffect(() => {
        setCurAvatar(useInfo?.avatar || 1);
    }, [useInfo]);

    const doChangeAvatar = async () => {
        const loadToast = Toast.show({
            icon: "loading",
            duration: 0,
        });
        try {
            const res = await changeUserInfo({
                avatar: curAvatar,
                nick_name: useInfo?.nick_name || "",
            });
            if (res.code === 200) {
                Toast.show({ icon: "success", content: t("success") });
                if (typeof onClose === "function") {
                    onClose(true);
                }
            }
        } catch {
            loadToast.close();
        }
    };

    const close = () => {
        if (typeof onClose === "function") {
            onClose();
        }
    };

    return (
        <Mask visible={visible} onMaskClick={close}>
            <div className={styles.Dialog}>
                <div
                    className={clsx(styles.DialogContainer, {
                        [styles.visible]: innerVisible,
                    })}
                >
                    <div className={styles.content}>
                        <div className={styles.title}>Selecione um Avatar</div>
                        <div className={styles.curHeader}>
                            <img src={HeaderImageMap.get(curAvatar)?.img} alt="" />
                        </div>
                        <div className="text-center text-[.12rem]">Alterar sua foto de perfil</div>

                        <div className={styles.imgs}>
                            {imgs.map((item) => {
                                return (
                                    <div
                                        key={item.key}
                                        className={clsx(styles.imgItem, {
                                            [styles.active]: curAvatar == item.key,
                                        })}
                                        onClick={() => {
                                            setCurAvatar(item.key);
                                        }}
                                    >
                                        <img src={item.img} alt="" />
                                        <span className={styles.check}>
                                            <i className="iconfont icon-gouxuan1 text-[.1rem]"></i>
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                        <div
                            className="mt-[.1rem] rounded-[.2rem] bg-[#11de68] py-[.08rem] text-center text-[.18rem] font-bold text-[#12171a]"
                            onClick={doChangeAvatar}
                        >
                            Claro
                        </div>
                    </div>
                    <div className={clsx(styles.close)} onClick={close}>
                        <i className={clsx("iconfont icon-guanbi relative z-10 text-[.14rem]")}></i>
                    </div>
                </div>
            </div>
        </Mask>
    );
};

export default ChangeAvatar;
